import Breadcrumb from '../../core/components/UI/Breadcrumb'
import { useCountryContext } from '../../core/context/country/CountryProvider'
import FormCreateMineralCountry from '../components/mineral-country-create/FormCreateMineralCountry'
import { useMineralContext } from '../context/mineral/mineralProvider'

export default function MineralCountryCreatePage() {
  const { mineralState } = useMineralContext()
  const { countryState } = useCountryContext()
  return (
    <>
      <Breadcrumb
        links={[
          {
            id: 1,
            label: 'المعادن',
            isActive: false,
            to: '/minerals',
          },
          {
            id: 2,
            label: mineralState.mineral?.name_ar,
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}`,
          },
          {
            id: 3,
            label: 'المناطق',
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}/countries`,
          },
          {
            id: 4,
            label: countryState.country?.name_ar,
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}/countries/${countryState.country?.id}`,
          },
          {
            id: 5,
            label: 'إضافة',
            isActive: true,
          },
        ]}
      />
      <div className="border-2 border-muted-500 bg-white p-2">
        <FormCreateMineralCountry />
      </div>
    </>
  )
}
